import { logOut, updateLocalStorageToken } from "../../../../containers/resources/utils";
import RouteService from "../../../../services/catalogs/RouteService";

export const REQUEST_CREATE_ROUTE = "REQUEST_CREATE_ROUTE";
export const CREATE_ROUTE_SUCCESS = "CREATE_ROUTE_SUCCESS";
export const CREATE_ROUTE_ERROR = "CREATE_ROUTE_ERROR";

function requestCreateRoute() {
  return {
    type: REQUEST_CREATE_ROUTE,
  };
}

function createRouteSuccess(json) {
  return {
    type: CREATE_ROUTE_SUCCESS,
    message: json.data,
  };
}

function createRouteError(json) {
  return {
    type: CREATE_ROUTE_ERROR,
    error: json.data,
  };
}

export function createRoute(payload) {
  return (dispatch) => {
    dispatch(requestCreateRoute());
    return RouteService.postRoute(payload).then((json) => {
      if (json.data.code === 200) {
        dispatch(createRouteSuccess(json.data));
      } else if (json.data.code === 202) {
        updateLocalStorageToken(json.data.token);
        dispatch(createRoute(payload));
      } else if (json.data.code === 498) {
        logOut();
      } else {
        dispatch(createRouteError(json.data));
      }
    });
  };
}
